import * as angular from "angular";
import {TableColumnSizeType} from "../../commons/types/table-column-size.type";

const importSampleFileLink = 'https://firebasestorage.googleapis.com/v0/b/bringoz-prod-imgs/o/import-xls-temp%2FBringoz_orders_upload_template_v4.xlsx?alt=media&token=88461cc4-afa2-41d5-af40-d71193cfcfe7&_gl=1*zgrjdd*_ga*MTgxODMxOTcwMS4xNjc5MzQ2NDAy*_ga_CW55HF8NVT*MTY5ODk0MDIzNS45MC4xLjE2OTg5NDAzMTcuNTIuMC4w';

const statusList3pls = [
  'Unassigned',
  'Assigned',
  'Started',
  'Canceled',
  'Completed'
];

const supplierTypes = [
  'Uber',
  'Roadie',
  'Postmates',
  'UPS',
  'Doordash',
  'USPS'
]

const autoShipmentCreationRuleTypes = [
  'Internal',
  '_3Pls'
]

const oms3plActions = [
  {
    title: 'Assign',
    action: 'Assign',
    icon: 'assign',
    permission: 'oms.orders.update'
  },
  {
    title: 'Edit',
    action: 'Edit',
    icon: 'edit',
    permission: 'oms.orders.update'
  },
  {
    title: 'Print Label',
    action: 'Print',
    icon: 'print',
    permission: 'oms.orders.update'
  },
  {
    title: 'Cancel',
    action: 'Cancel',
    icon: 'close-circle',
    permission: 'oms.orders.delete'
  }
];

const tableColumnsMap = {
  account: {enabled: true, order: 1, permission: undefined, size: TableColumnSizeType.large},
  accountExternalId: {enabled: false, order: 2, permission: undefined, size: TableColumnSizeType.medium},
  branches: {enabled: false, order: 3, permission: undefined, size: TableColumnSizeType.medium},
  contact: {enabled: true, order: 4, permission: undefined, size: TableColumnSizeType.small},
  phone: {enabled: true, order: 5, permission: undefined, size: TableColumnSizeType.small},
  location: {enabled: true, order: 6, permission: undefined, size: TableColumnSizeType.large},
  relations: {enabled: true, order: 7, permission: undefined, size: TableColumnSizeType.large},
  programType: {enabled: true, order: 8, permission: undefined, size: TableColumnSizeType.small},
  sla: {enabled: true, order: 9, permission: undefined, size: TableColumnSizeType.small},
  timeToDeliver: {enabled: true, order: 10, permission: undefined, size: TableColumnSizeType.small},
  createdAt: {enabled: true, order: 11, permission: undefined, size: TableColumnSizeType.small},
  proNumber: {enabled: true, order: 12, permission: undefined, size: TableColumnSizeType.small},
  fulfillmentStatus: {enabled: false, order: 13, permission: undefined, size: TableColumnSizeType.small},
  schedulingSms: {enabled: false, order: 14, permission: undefined, size: TableColumnSizeType.medium},
  itemsIds: {enabled: false, order: 15, permission: undefined, size: TableColumnSizeType.small},
  itemsTypes: {enabled: false, order: 16, permission: undefined, size: TableColumnSizeType.small},
  itemsBarcodes: {enabled: false, order: 17, permission: undefined, size: TableColumnSizeType.small},
  referenceIds: {enabled: false, order: 18, permission: undefined, size: TableColumnSizeType.small},
  notes: {enabled: false, order: 19, permission: undefined, size: TableColumnSizeType.large},
  billingOrder: {enabled: false, order: 20, permission: undefined, size: TableColumnSizeType.small},
  pallets: {enabled: false, order: 21, permission: undefined, size: TableColumnSizeType.small}
}

angular
  .module('bringoz.admin.oms')
  .constant('omsConstants', {
    importSampleFileLink: importSampleFileLink,
    statusList3pls: statusList3pls,
    supplierTypes: supplierTypes,
    autoShipmentCreationRuleTypes: autoShipmentCreationRuleTypes,
    oms3plActions: oms3plActions,
    tableColumnsMap: tableColumnsMap
  });

